window.Colors = 
  white : "#EEEEEE"
  grey : "#DDDbDa"
  red : "#F17F63"
  green : "#99DD5C"
  yellow : "#FEF464"
  blue :  "#1D62AF"
  aqua : "#26ABE2"
  pink : "#F27E90"
  dark : "#444444"
  dark_grey : "#BBBaB9"
Rainbow =[Colors.grey, Colors.yellow, Colors.green, Colors.aqua, Colors.blue, Colors.pink, Colors.red, Colors.dark, Colors.yellow]
Rainbow_accent =[Colors.dark, Colors.dark, Colors.dark, Colors.dark, Colors.aqua, Colors.dark, Colors.dark, Colors.white]
darken = (c) ->
  ds = "0123456789ABCDEF".split("")
  c.split("").map((i) -> 
    if i is "#" 
      i
    else
      index = ds.indexOf i
      if index > 0
        ds[index - 1]
      else
        i
  ).join("")

lighten = (c) -> c + "99"

class Layout
  constructor : (mobile) ->

    @w = window.innerWidth
    @h = window.innerHeight
    @page_width = if mobile then @w else 600

    @page = 
      x : @w - @page_width
      y : 0
      w : @page_width
      h : @h

    @gl = 
      x : @bezel.side * @phone.w + @phone.x
      y : @bezel.top * @phone.h
      w : @phone.w - (@bezel.side * @phone.w) * 2
      h : @phone.h - ((@bezel.top + @bezel.bottom) * @phone.h)

    @logos = 
      x : 0
      y : @screen.h - @screen.h * @logos_ratio
      w : @screen.w
      h : @screen.h * @logos_ratio

class Domer
  constructor : () ->

  menu_button : (p, i, array) ->
    capitalize = (t) -> 
      t[0].toUpperCase() + t.substring(1)
    h = (innerHeight / array.length)
    anim = if i is Stages.length - 1 then "rainbow 1s linear infinite" else "none"
    $("<button>", {
      class : "menu_item"
      css : 
        top : 0
        height : h
      html : [
        $("<div>"
          id : p.id + "_icon"
          class : "menu_icon"
          css : 
            position : "absolute"
            borderRadius : "50%"
            backgroundColor : Rainbow[i] + "ea"
            animation : anim
        ).css(
          if isMobile.phone
            top : "35%"
            left : "20%"
            width : "60%"
            height : "30%"
          else
            top : "25%"
            left : "25%"
            width : "50%"
            height : "50%"
        )
      ]
      id : p.id 
      mouseleave : (e) =>
        $("#menu-tooltip").hide()
      mouseenter : (e) =>
        y = $(e.currentTarget).position().top + 
        max_rot = -0.15
        r = i * (1 / Rainbow.length) - 0.5
        t = Pages.find((p) -> p.id is e.currentTarget.id).title

        if @current.title is t and @page_opened()
          t = "X"

        $("#menu-tooltip").css(
          top : y + (-r) * 40
          height : h
          marginLeft : 0
          fontSize : h * 0.5
          paddingTop : h * 0.125
          backgroundColor : Rainbow[i]
          animation : anim
          color : Rainbow_accent[i]
          opacity : 1
          # color : Rainbow[Rainbow.length - 1 - i]
          transform : "rotate3d(0, 1, #{r * -max_rot}, 0.93turn)"
        ).html(#$("<h1>", 
          t
        # )
        ).show()
      click : (e) => 
        p = Pages.find((p) -> p.id is e.currentTarget.id)

        if isMobile.phone
          $("#menu-tooltip").hide()
          @open_page p.id
        else
          if p.id is @current.id
            if @current.id isnt "nyertesek"
              enabled = @toggle_page()
              $("#menu-tooltip").html(if enabled then "X" else p.title)
          else
            @open_page p.id
            $("#menu-tooltip").html("X")
      }
    )
  page_opened : () ->
    $("#page").css("opacity") isnt "0"
  update_score : (s) ->
    h = @score.height()
    r = if s > 9 then 0.6 else if s is 1 then 0.65 else 0.7
    p = if s > 9 then 0.11 else 0.02
    for stage, i in Stages
      $("##{Pages[i].id}_icon").css(
        borderRadius : (if stage.finished() then "10%" else "50%")
      )

    if s is 0 
      @score.html ""
    else
      @score
        .html(s)
        .css(
          fontSize : h * r
          paddingTop : h * p
          textAlign : "center"
          borderRadius : if s > 0 then "10%" else "50%"
        )
  english : false
  create_menu : () ->
    ps = Pages.slice(0,Pages.length - 1)
    $("#english").unbind "click"
    $("#english").click (e) => 
      if @current.id = "nyertesek"
        @english = not @english
        $($("#english").children()[0]).html if @english then "HU" else "EN"
        @open_page "nyertesek", true, @current_winner, @english
      else
        @open_page "english"
    h = (innerHeight / ps.length) / (if isMobile.phone then 2 else 1)
    $("#menu").html( ps.map @menu_button.bind(@) ).css("width", h).show()
    if isMobile.phone
      $("#jatek").hide()
    @score = $("#jatek_icon")

  logo_id : 0
  init_logos : () ->
    @logos_ready = true
    $("#logo-buffer").remove()
    $("#ads").prepend $("<div>", id : "logo-buffer")
    ls = $("#logo-container").children()
    widest = ls.toArray().reduce(((a, v, i) -> 
          _w = $($(v).children()[0]).width()
          if a < _w then _w else a)
      ,0
    )
    for l, i in ls
      e = $(ls[i])
      w = $(e.children()[0]).width()
      e.css "margin-left", (widest - w) * 0.5
      e.data "index", i

    # fs = $("#fix-logos").children()
    # for f, i in fs
    #   e = $(fs[i])
    #   e.css "margin-left", (widest - w) * 0.5

    $("#logo-container").hide()
  cycle_logos : () ->
    $("#logo-buffer").children().appendTo($("#logo-container"))

    ls = $("#logo-container").children()

    ls.sort (a, b) -> $(a).data("index") - $(b).data("index")
    $("#logo-container").append ls

    y = parseInt $("#ads").css("padding-top")
    h = 81
    wh = window.innerHeight - y - $("#fix-logos").height() + h
    max_logos = Math.floor(wh / h)
    # max_logos = 3

    rs = []
    for i in [0..max_logos - 1]
      offset = (i + @logo_id) % ls.length
      rs.push $(ls[offset])

    $("#logo-buffer").append rs

    if max_logos isnt ls.length
      @logo_id = (@logo_id + 1) % ls.length

    $("#fix-logos").css
      top : window.innerHeight - $("#fix-logos").height()

  init : () ->
    @scroll_box = $(".simplebar-content-wrapper")
    @page = $("<div>", id : "page-container").attr("scrolling", "no").get(0)
    $("#inner .simplebar-content").html @page

    $("#ads").load("pages/logos.html", () =>
      @init_logos()
      @cycle_logos()
      window.setInterval(@cycle_logos.bind(@), 3000)
    )

    if isMobile.phone
      $("#page").css(
        left : 0
        top : 0
        width : "100%"
        height : "100%"
        transform: "rotate3d(0, 0, 1, 0.0turn)"
        paddingLeft : "4em";
      )
      $("#menu").css(
        left : 0
      )
      $("body").css(
        fontSize : "0.8em"
      )

      $("#ads").css(

        left : "100%"
        top : 0
        width : "100%"
        height : "100%"
        transform: "rotate3d(0, 0, 1, 0.0turn)"
      )
      $("#page-container").css 
        padding : "1.5em"
      $("#english").css
        bottom : 0
        left : "1em"
        right : "none"
        fontSize : "70%"
        display : "block"
        transform: "";

    else
      $("#english").css
        right : "3em"
        top : "1em"
        display : "block"
        transform: "rotate3d(0, 0, 1, 0.006turn)";
    @create_menu()
  resize : (w, h) ->
    w = w - $("#page").position().left
    if @logos_ready
      @cycle_logos()

    $("#nyertes-title").css("min-height", window.innerHeight)
    # $(".nyertes-list").css("padding-top", window.innerHeight)


    @create_menu()
  is_mobile : () ->
    isMobile.phone or window.innerWidth < window.innerHeight

  resize_iframe : () ->
    $("iframe").css  height : 0
    doc = @page.contentWindow.document
    body = doc.body
    html = doc.documentElement
    h = Math.max( 
      body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight )
    # h = @page.contentDocument.getElementsByClassName("pages")[0].scrollHeight
    h = height : "#{h + (if isMobile.phone then 200 else 200)}px"
    $("iframe").css  h
    $("#inner .simplebar-content-wrapper").css  h 

  toggle_page : (force) ->

    p = $("#page")
    enable = if force? then force else p.css("opacity") is "0"
    if enable
      p.css
        opacity : 1
        "pointer-events" : "inherit"
    else
      p.css
        opacity : 0
        "pointer-events" : "none"
    return enable
  show_info : () ->
    s = if Main.world? then Main.world.score else 0
    if s is 19
      t = """
        <p> Elértél a játék végére!</p>
        <p> Itt az ideje, hogy jelentkezz a versenyünkre!</p>
      """
      $("#jatek-title").html "gratulálunk!"
      $("#jatek-info").html t
    else
      t = """
      <p>
        Ha ennek örömére játszanál egyet, találd meg a hátterekben elrejtett kakukk-tojásokat!
      </p>

      <p>
        Azért a versenyre se felejts el nevezni!
      </p>
      <p>
        #{if s is 0 then "Még egy kakukk-tojást sem fedeztél fel..." else "Húha! Már #{s} hátteret megfejtettél, még #{19 - s} van hátra."}
      </p>
      """
      $("#jatek-info").html t


  current_winner : -1
  id_to_url : (id) ->
    monogramm = (n) ->
      a = n.split(" ")[0][0]
      if n.split(" ")[0][1] is "y"
        a += "Y"
      b = n.split(" ")[1][0]
      a + b
    _Nyertesek[id].name.map(monogramm).join("").replace("Á", "A")
  url_to_id : (url) ->
    for n, i in _Nyertesek
      if @id_to_url(i) is url
        return i
    return null
  current_video : () ->
    if @current_winner isnt -1
      $("#page").find(".winner-video").get(@current_winner)
  toggle_video : (t) ->
    v = $("#page").find(".winner-video")[t]
    if v.playing
      v.pause()
    else
      v.play()
    @solo_video t
  solo_video : (t) ->
    vs = $("#page").find(".winner-video")
    for v, i in vs
      if i isnt t
        v.pause()

    if t isnt -1
      vs[t].focus(preventScroll : true)


  winner_page : (w, i) ->
    $("<div>", 
      class : "winner-block",
      id : @id_to_url i
      css : 
        backgroundColor : if i % 2 is 1 then Colors.dark_grey else Colors.grey
      html : [
        $("<h2>", class : "winner-name flow-text", html : w.name.join(", "))
        $("<h1>", class : "winner-title", html : w.title)
        $("<video>", id : "#winner-video_#{i}", class : "winner-video", 
          # html : "<source src=\"#{w.video_link}\"></source>"
        ).attr
          crossorigin : "anonymous"
          controls : "controls"
          preload : "auto"
          src : w.video_link
        # "data-setup" : ""
        .show()
        .on "play", (e) => @solo_video parseInt(e.currentTarget.id.split("_")[1])
        .on "keydown", (e) =>
          switch e.originalEvent.code
            when "KeyF"
              if @current? and @current.id is "nyertesek"
                if @current_winner isnt -1
                  Main.request_fullscreen(@current_video(), not document.fullscreen)
        $("<div>", id : "winner-text", class : "flow-text", html : w.text)
      ]
    )
    # $(d).find("#winner-names").html w.name.join(", ")
    # $(d).find("#winner-text").html w.text
    # $(d).find("#winner-title").html w.title
    # $(d).find("#winner-video").show().attr "src", w.video_link
  get_winner_url : (id) ->
    nt = 
      if id is -1
        ""
      else
        "/" + @id_to_url(id)

    l = if @english then "winners" else "nyertesek"
    document.location.pathname + "##{l}" + nt
  set_winner_url : (id) ->    
    history.replaceState(null, null, @get_winner_url(id))
      # if window.location.href isnt nt
      #   window.location.href = nt

  jump_to_winner : (id) ->
    offset = 
      if id is -1 
        0
      else
        $(@page).find("##{@id_to_url(id)}")[0].offsetTop + 10

    $("#inner .simplebar-content-wrapper").css("scroll-behavior", "unset").scrollTop offset
  scroll_to_winner : (id) ->
    offset = 
      if id is -1 
        0
      else
        $(@page).find("##{@id_to_url(id)}")[0].offsetTop - 10

    $("#inner .simplebar-content-wrapper").css("scroll-behavior", "smooth").scrollTop offset
    $("#inner .simplebar-content-wrapper").css("scroll-behavior", "unset")
  step_winner : (d) ->
    @current_winner = clamp(@current_winner + d, -1, _Nyertesek.length - 1)
    @scroll_to_winner @current_winner
    @set_winner_url @current_winner
    @solo_video @current_winner
  get_winner_top : (i) ->
    if i is -1 
      return 0
    else
      $(@page).find("##{@id_to_url(i)}")[0].offsetTop

  scroll_winner_page : (e) ->

    if @current.id isnt "nyertesek" then return false
    prev_id = clamp(@current_winner - 1, -1, _Nyertesek.length - 1)
    next_id = clamp(@current_winner + 1, 0, _Nyertesek.length - 1)

    current = @get_winner_top @current_winner
    next = @get_winner_top next_id
    prev = @get_winner_top prev_id

    nt = @current_winner
    dead_zone = 100
    # dead_zone = innerHeight / 3
    scroll_top = $("#inner .simplebar-content-wrapper").scrollTop() + dead_zone
    scroll = scroll_top / $("#inner .simplebar-content-wrapper").outerHeight()
    $("#page").css backgroundColor : "#" + new THREE.Color(Colors.yellow).lerp(new THREE.Color(Colors.grey), clamp(scroll, 0, 1)).getHexString()
    if scroll_top < current
      nt = prev_id
    else if scroll_top > next
      nt = next_id

    if @current_winner isnt nt
      # console.log @current_winner, "->", nt
      @current_winner = nt
      @set_winner_url nt
      @solo_video nt
  winner_list : (english) ->
    _Nyertesek.map((w, i) =>
      $("<h2>", html : $("<a>", html : w.name.join(" "), href : @get_winner_url(i)), class : "winner-name", css: {"text-align" : "center"})
    )
  set_winner_header_lang : (english) ->
    text = 
      if english
        title : "Shape Your World!"
        subtitle : "Freestyle Computing Competition"
        date : "2021 Winners"
      else
        title : "Formáld a világod!"
        subtitle : "Szabadfogású Számítógép Verseny"
        date : "2021 Nyertesek"
    $(".nyertes-title").html text.title
    $(".nyertes-date").html text.date
    $(".nyertes-subtitle").html text.subtitle
    $(".nyertes-list").css("padding-top" : innerHeight - $("#nyertesek").outerHeight() * 2, "padding-bottom" : "10em").html @winner_list(english)


  open_winner_page : (index, english = false) ->
    # if not force and @current_winner is index
    #   return

    @english = english

    @current_winner = index
    @set_winner_url @current_winner


    ws = 
      if @english
        _Winners.map((w, i) -> 
          w.video_link = _Nyertesek[i].video_link
          w
        )
      else 
        _Nyertesek

    for w, i in ws
      wp = @winner_page w, i
      @page.append wp.get(0)


    @set_winner_header_lang @english




    $("#nyertes-title").css("min-height", window.innerHeight)

    # $("#inner .simplebar-content-wrapper").scrollTop @get_winner_top @current_winner
    @jump_to_winner @current_winner

    $("#inner .simplebar-content-wrapper").on "scroll",  (e) => 
      @scroll_winner_page e
        # console.log @current_winner
    # @resize_iframe()
    # else
    #   if callback? then callback d, @current_winner, force
      
  open_page : (id, force = false, sub = -1, english = false) ->

    @scroll_box.scrollTop(0)
    cp = Pages.find((p) -> p.id is id)

    if not force and @current? and cp.id is @current.id
      return

    cid = if @current? then @current.id else id
    last_i = Pages.findIndex((p) -> p.id is cid)

    if @current?
      switch @current.id
        when "szponzorok"
          $("#ads").show()
        when "jatek"
          $("#gui").hide().appendTo($("body"))


    @current = cp

    if @current.id is "szponzorok"
      $("#ads").hide()

    i = Pages.findIndex((p) -> p.id is id)

    if i < Pages.length - 1
      if Main.world?
        Main.world.open(i)

    if @page?
      $(@page).load @current.source, () =>
        if @current.id is "jatek"
          @show_info()
          
        @toggle_page true
        opacity = if isMobile.phone then "ea" else "f8"
        c = Rainbow[i] + opacity
        # $("#menu, #page, #ads").toggle()

        color = 
          switch id
            when "szponzorok"
              Colors.white + opacity
            when "jatek"
              Colors.white + opacity
            when "english"
              Rainbow[if last_i is 4 then 3 else last_i] + opacity
            else
              c
        $('meta[name=theme-color]').attr('content', color);

        $("#page").css "background-color", color

        if @current.id is "nyertesek"
          @open_winner_page sub, english





    window.location.hash = @current.id

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: () ->
      return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
})